<template>
  <div class="home-page-slider">
    <swiper :options="swiperOption" v-if="slides[0] && slides[0].image">
      <swiper-slide class="slide" v-for="(slide, index) in slides" :key="index"
        :style="{ 'background-image': 'radial-gradient(100% 30% at top left, oklch(0.18 0.06 258.68 / 0.8) 10%, transparent 122%), url(' + slide.image + ')' }">
        <div class="slider-caption">
          <h2 data-swiper-parallax="-100%" :style="{ color: customization.mainColor }">
            {{ slide.slideTitle }}
          </h2>
          <span class="subtitle" data-swiper-parallax="-60%">{{
            slide.slideSubTitle
          }}</span>
          <div v-if="slide.slideText" class="divider" :style="{ 'background-color': customization.mainColor }"></div>
          <p data-swiper-parallax="-30%">
            {{ slide.slideText }}
          </p>
        </div>
        <referral-panel data-swiper-parallax="-100%" v-if="index === 0" />
      </swiper-slide>
    </swiper>
    <div v-if="slides && slides.length" class="swiper-pagination" slot="pagination"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ReferralPanel from './referral-panel.vue'

export default {
  name: 'home-page-slider',
  components: {
    swiper,
    'swiper-slide': swiperSlide,
    'referral-panel': ReferralPanel
  },
  props: {
    slides: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization
    })
  },
  data () {
    return {
      swiperOption: {
        parallax: true,
        pagination: '.swiper-pagination'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.home-page-slider {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  .swiper-pagination {
    position: static;
    margin-top: auto;
    align-self: center;
  }
}

.slide {
  display: flex;
  flex-direction: column;
}

.referral-panel {
  box-sizing: border-box;
  margin-top: auto;
  margin-bottom: 24px;
  margin-inline: 8px;
  align-self: center;
  z-index: 1;
}

.swiper-slide>img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.swiper-slide {
  box-shadow: none;
}

.slider_trans {
  position: absolute;
  inset: 0;
}

.slider-caption {
  color: white;
}

.slider-caption h2 {
  font-size: 1.5em;
}

.slider-caption p {
  margin: 0;
}

.slider-caption .divider {
  height: 1px;
  width: 65px;
  margin-block: .5rem;
}

.active span {
  display: block;
}

.slide-overlay {
  position: absolute;
  inset: 0;

}
</style>

<style>
.swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  display: inline-block;
  border: solid 1px #000;
  margin-right: 2px;
}

.swiper-container {
  position: absolute;
  overflow: hidden;
  inset: 0;
}

.swiper-slide {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// home-page-slider.component.vue?7d85ed4e